const toBase64 = (input) => {
  // Check if input is ArrayBuffer, then convert it to Uint8Array
  if (input instanceof ArrayBuffer) {
    input = new Uint8Array(input);
  }

  if (!(input instanceof Uint8Array)) {
    console.error("[toBase64] Invalid input, expected Uint8Array:", input);
    throw new TypeError("Expected Uint8Array in toBase64");
  }

  const base64 = btoa(String.fromCharCode(...input));
 /*  console.log("[toBase64] Encoded base64:", base64.slice(0, 60) + "..."); */
  return base64;
};

async function importRSAPublicKey(pem) {
  /* console.log("[importRSAPublicKey] Input PEM:", pem?.slice(0, 100) + "..."); */

  if (!pem || typeof pem !== "string") {
    console.error("[importRSAPublicKey] Invalid PEM input:", pem);
    throw new Error("Public key PEM is missing or invalid.");
  }

  const b64 = pem
    .replace(/-----(BEGIN|END) PUBLIC KEY-----/g, "")
    .replace(/\s+/g, "");

  /* console.log("[importRSAPublicKey] Extracted base64 content:", b64.slice(0, 60) + "..."); */

  const binaryDer = Uint8Array.from(atob(b64), c => c.charCodeAt(0));
  /* console.log("[importRSAPublicKey] Converted PEM to DER format"); */

  return crypto.subtle.importKey(
    "spki",
    binaryDer.buffer,
    { name: "RSA-OAEP", hash: "SHA-256" },
    false,
    ["encrypt"]
  );
}

async function generateAESKey() {
 /*  console.log("[generateAESKey] Generating AES key..."); */
  const key = await crypto.subtle.generateKey(
    { name: "AES-GCM", length: 256 },
    true,
    ["encrypt", "decrypt"]
  );
  console.log("[generateAESKey] AES key generated.");
  return key;
}

async function encryptDataWithAES(aesKey, data) {
  /* console.log("[encryptDataWithAES] Encrypting data with AES-GCM..."); */
  const iv = crypto.getRandomValues(new Uint8Array(12));
 /*  console.log("[encryptDataWithAES] IV generated:", iv); */

  const encoded = new TextEncoder().encode(JSON.stringify(data));
  const ciphertext = await crypto.subtle.encrypt({ name: "AES-GCM", iv }, aesKey, encoded);

  /* console.log("[encryptDataWithAES] AES encryption complete."); */
  return { ciphertext: new Uint8Array(ciphertext), iv };
}

async function exportAESKey(aesKey) {
  /* console.log("[exportAESKey] Exporting AES key (raw bytes)..."); */
  const raw = await crypto.subtle.exportKey("raw", aesKey);
  /* console.log("[exportAESKey] AES key exported."); */
  return new Uint8Array(raw);
}

async function encryptAESKeyWithRSA(rsaPublicKey, rawKeyBytes) {
  /* console.log("[encryptAESKeyWithRSA] Encrypting AES key using RSA..."); */
  const encrypted = await crypto.subtle.encrypt(
    { name: "RSA-OAEP" },
    rsaPublicKey,
    rawKeyBytes
  );
 /*  console.log("[encryptAESKeyWithRSA] AES key encrypted."); */
  return encrypted;
}

export async function encryptPayload(data, publicKeyPem) {
  /* console.log("[encryptPayload] Starting encryption process...");
  console.log("[encryptPayload] Input data:", data); */

  const rsaPublicKey = await importRSAPublicKey(publicKeyPem);
  const aesKey = await generateAESKey();
  const { ciphertext, iv } = await encryptDataWithAES(aesKey, data);
  const rawAESKey = await exportAESKey(aesKey);
  const encryptedAESKey = await encryptAESKeyWithRSA(rsaPublicKey, rawAESKey);

  /* console.log("[encryptPayload] Encryption complete. Returning encrypted payload."); */

  return {
    encrypted_aes_key: toBase64(encryptedAESKey),
    iv: toBase64(iv),
    ciphertext: toBase64(ciphertext),
  };
}
